import { render } from "./ZDFPlayer.vue?vue&type=template&id=cdd51d34"
import script from "./ZDFPlayer.vue?vue&type=script&lang=js"
export * from "./ZDFPlayer.vue?vue&type=script&lang=js"

import exportComponent from "D:\\___PROJEKTE\\__ZDF\\Babylon_Projekte\\231214_Zugspitze_Update\\231214_Zugspitze_Update\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__